import React, { useState, useEffect } from "react";
import { Row, Col, Table } from "react-bootstrap";
import { Content, Sidebar, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import useWrapper from "../../../hooks/useWrapper";
import api from "../../../services/api";
import TableResponsive from "../../../components/TableResponsive";
import { formatDate, formatReal } from "../../../util/functions";
import ModalProductTrainee from "../../../components/Modal/modal-product-trainee";
import Button from "../../../components/Button";
import usePaymentSlip from "../../../hooks/api/usePaymentSlip";
import StatusFlag from "../../../components/StatusFlag";
import Dropdown2 from "../../../components/Dropdown";
import { toast } from "react-toastify";
import Loading from "../../../components/Loading";

export default function Produtos() {
  const { config, me, loadMe } = useWrapper();
  const [customPaymentSlip, setcustomPaymentSlip] = useState();

  const [loading, setloading] = useState(true);
  const {
    data: paymentSlips2,
    setquery: setpaymentSlipQuery,
    reload: reloadSlips,
    load: loadSlips,
  } = usePaymentSlip({ is_trainee: true });
  useEffect(() => {
    setpaymentSlipQuery(`?paginate=false&trainee_id=${me.id}&!custom_payment_id=null`);
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (me?.paymentSlip) {
          const custom_payment_slip =
            me?.paymentSlip?.filter(__payment_slip => !!__payment_slip.custom_payment_id) || [];
          setcustomPaymentSlip(custom_payment_slip);
          reloadSlips(JSON.stringify(new Date()));
        }
      } catch (__error) {
        toast.error("Erro ao carregar os dados, tente novamente.");
        console.log("__error", __error);
      }
    })();
  }, [JSON.stringify(me?.paymentSlip)]);

  const [productModal, setproductModal] = useState({
    show: false,
    product_pre_load: null,
  });
  const [customPayment, setcustomPayment] = useState();
  useEffect(() => {
    if (!!customPaymentSlip) {
      (async () => {
        try {
          setloading(true);
          const { data: custom_payment } = await api.get(`trainee/custom-payment?type_method=produto`, config);
          let _custom_payment = custom_payment.map(__custom_payment => ({
            ...__custom_payment,
            has_amount: customPaymentSlip
              .filter(__custom_payment_slip => __custom_payment_slip.custom_payment_id === __custom_payment.id)
              .filter(__custom_payment_slip => __custom_payment_slip.status !== "cancelado")
              .reduce((__acc, __current) => __acc + Number(__current.aditional_information), 0),
          }));
          setcustomPayment(_custom_payment);
        } catch (__error) {
          toast.error("Erro ao carregar os dados, tente novamente.");
          console.log("__error", __error);
        } finally {
          setloading(false);
        }
      })();
    }
  }, [customPaymentSlip]);

  return (
    <>
      <ModalProductTrainee
        show={productModal?.show}
        closeModal={() => {
          setproductModal({ show: false, id: null });
        }}
        productPreLoad={productModal.product_pre_load}
        has_amount={productModal.has_amount}
      />
      <Main className={style.mainUser}>
        <Content noBG="true">
          <Row>
            <Col md={12} lg={2}>
              <MenuTrainee />
            </Col>
            <Col>
              {!loading ? (
                <>
                  <SubContent>
                    <h2 className="form-title">Produtos Disponíveis</h2>
                    <p className="small-label mb-3">
                      Consulte os produtos atualmente disponíveis para compra. Verifique o período de disponibilidade, a
                      quantidade já adquirida em relação ao estoque total e o valor unitário antes de realizar sua
                      solicitação.
                    </p>
                    <TableResponsive
                      table={{
                        head: [
                          { data: "Produto" },
                          { data: "Disponibilidade" },
                          { data: "Quantidade Adquirida/Disponível" },
                          { data: "Valor" },
                          { data: "" },
                        ],
                        body:
                          customPayment?.map(__payment => ({
                            onClick: () => {
                              setproductModal({
                                show: true,
                                product_pre_load: __payment,
                                has_amount: __payment.has_amount,
                              });
                            },
                            data: [
                              { element: __payment.name },
                              {
                                element: `${formatDate(__payment.date_start, 2)} ~ ${formatDate(__payment.date_end, 2)}`,
                              },
                              {
                                element: `${__payment.has_amount}/${__payment.quantity}`,
                              },
                              {
                                element: formatReal((__payment.value || 0) + (__payment.contribution_value || 0)),
                              },
                              {
                                element:
                                  __payment.has_amount < __payment.quantity ? (
                                    <div className="text-end">
                                      <Button size="sm">Comprar</Button>
                                    </div>
                                  ) : (
                                    ""
                                  ),
                              },
                            ],
                          })) || [],
                      }}
                    />
                    {!paymentSlips2?.lenght > 0 ? (
                      <>
                        <h2 className="form-title mt-4">Compras</h2>
                        <p className="small-label mb-3">
                          Acompanhe todas as suas compras realizadas. Consulte valores, vencimentos, status do
                          processamento e utilize o menu de ações para visualizar detalhes ou efetuar pagamentos
                          pendentes.
                        </p>

                        <TableResponsive
                          table={{
                            head: [
                              { data: "Código" },
                              { data: "Produto" },
                              { data: "Quantidade" },
                              { data: "A Pagar/Pago" },
                              { data: "Vencimento/Pagamento" },
                              { data: "Parcela" },
                              { data: "Status" },
                              { data: "Ações" },
                            ],
                            body:
                              paymentSlips2?.data
                                ?.filter(__payment => __payment?.status !== "Cancelado")
                                ?.map((__payment, __payment_i) => ({
                                  disabled: __payment.status === "Cancelado",
                                  data: [
                                    {
                                      element: <span>{__payment.id}</span>,
                                    },
                                    {
                                      element: <span>{__payment?.custom_payment?.name}</span>,
                                    },
                                    {
                                      element: <span>{__payment?.aditional_information || "?"}</span>,
                                    },
                                    {
                                      element: (
                                        <span>
                                          <b>
                                            {formatReal(
                                              __payment.value_paid ||
                                                (__payment.value || 0) + (__payment.value_juros || 0),
                                            )}
                                          </b>
                                        </span>
                                      ),
                                    },
                                    {
                                      element: (
                                        <span>{formatDate(__payment.payment_date || __payment.due_date, 2)}</span>
                                      ),
                                    },
                                    {
                                      element: (
                                        <span>
                                          {__payment.quota}/{__payment.quotas_total}
                                        </span>
                                      ),
                                    },
                                    {
                                      element: (
                                        <span>
                                          <StatusFlag status={__payment.status} />
                                        </span>
                                      ),
                                    },
                                    {
                                      element: (
                                        <>
                                          {!(__payment.status === "Cancelado" || __payment.status === "Pago") && (
                                            <div className="text-right">
                                              <Dropdown2
                                                toggle={<span>...</span>}
                                                menu={[
                                                  {
                                                    label: "Download do Boleto",
                                                    action: () => {
                                                      if (__payment.boleto_url) {
                                                        window.open(__payment.boleto_url);
                                                      } else {
                                                        toast.error("O download deste boleto ainda está indisponível");
                                                      }
                                                    },
                                                  },
                                                  {
                                                    label: "Copiar Código",
                                                    action: () => {
                                                      if (__payment.bar_code) {
                                                        navigator.clipboard.writeText(__payment.bar_code);
                                                        toast.success("Código do Boleto copiado.");
                                                      } else {
                                                        toast.error("Esse boleto ainda não foi gerado.");
                                                      }
                                                    },
                                                  },
                                                ]}
                                              />
                                            </div>
                                          )}
                                        </>
                                      ),
                                    },
                                  ],
                                })) || [],
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </SubContent>
                </>
              ) : (
                <SubContent>
                  <Loading />
                </SubContent>
              )}
            </Col>
          </Row>
        </Content>
      </Main>
    </>
  );
}
